module.exports = __webpack_public_path__ + "img/privacidade.d8243df5.png";